export enum UserStatus {
  invitationPending = 'invitationPending',
  active = 'active',
  blocked = 'blocked',
}
